import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { connect as connectStaticText } from '../StaticText/connect'
import { getBoundActions } from '../../actions/index'
import EmailCapture from '../EmailCapture/index'
import Button, { TYPES } from '../Button/index'
import {
  H1, H2, H6, HEADING_TYPES,
} from '../Heading/index'
import Sherpa, { TYPE_SMALL } from '../Sherpa/index'
import { FORM_NAME_PREVIEW_GATE } from '../../services/form/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'

function getBackgroundImage (img) {
  const style = {
    backgroundImage: `url(${img})`,
  }
  return style
}

class VideoEmailGate extends Component {
  componentWillUnmount () {
    const { props } = this
    const { emailSignup, setEmailSignupPreviewGateVisible } = props
    const previewGateVisible = emailSignup.get('previewGateVisible')

    if (previewGateVisible) {
      setEmailSignupPreviewGateVisible(false)
    }
  }

  onClickClose = () => {
    const {
      history, emailSignup, video, setEmailSignupPreviewGateVisible,
    } = this.props
    const emailSignupCompleted = emailSignup.get('completed')
    const basePath = video.get('path')
    // if email signup is complete,
    // stay on the video page, remove the preview gate and play the preview
    if (emailSignupCompleted) {
      return setEmailSignupPreviewGateVisible(false)
    }

    // go to the detail page
    return history.push(basePath)
  }

  onClickLoginButton = () => {
    const { setOverlayDialogVisible } = this.props

    setOverlayDialogVisible(TYPE_LOGIN)
  }

  render () {
    const { props } = this
    const {
      video,
      staticText,
      emailSignup,
      doEmailSignup,
    } = props
    const siteSegment = video.getIn(['data', 'siteSegment'], Map())
    const image = video.getIn(['data', 'poster'])
    const processing = emailSignup.get('processing')
    const success = emailSignup.get('success')

    return (
      <div className="video-email-gate" style={getBackgroundImage(image)}>
        <div className="video-email-gate__overlay" />
        <Button
          type={TYPES.LINK}
          onClick={this.onClickClose}
          className="video-email-gate__close"
        >
          <IconV2 type={ICON_TYPES.CLOSE} />
        </Button>
        <div className="video-email-gate__content">
          {
            !success
              ? <div className="video-email-gate__title-wrapper">
                <div className="video-email-gate__border" />
                <H1 inverted className="video-email-gate__title">{staticText.getIn(['data', 'title'])}</H1>
                <H2 inverted className="video-email-gate__subtitle">{staticText.getIn(['data', 'enterEmailToUnlock'])}</H2>
              </div>
              : null
          }
          {
            processing
              ? <div className="video-email-gate__sherpa">
                <Sherpa type={TYPE_SMALL} />
              </div>
              : <React.Fragment>
                <EmailCapture
                  className={['video-email-gate__email-capture']}
                  buttonText={staticText.getIn(['data', 'unlockVideo'])}
                  inputPlaceholder={staticText.getIn(['data', 'emailAddress'])}
                  formName={FORM_NAME_PREVIEW_GATE}
                  success={emailSignup.get('success')}
                  successText={staticText.getIn(['data', 'thanks'])}
                  siteSegment={siteSegment}
                  onFormSubmit={doEmailSignup}
                  uiLocation="Preview Unlock"
                />
                {
                  !success
                    ? <div className="video-email-gate__login">
                      <H6 as={HEADING_TYPES.H5} className="video-email-gate__login-text">{staticText.getIn(['data', 'alreadyAMember'])}</H6>
                      <Button
                        type={TYPES.PRIMARY}
                        onClick={this.onClickLoginButton}
                        className="'video-email-gate__login-btn'"
                      >
                        {staticText.getIn(['data', 'login'])}
                      </Button>
                    </div>
                    : null
                }
              </React.Fragment>
          }
        </div>
      </div>
    )
  }
}

VideoEmailGate.propTypes = {
  history: PropTypes.object.isRequired,
  video: ImmutablePropTypes.map.isRequired,
  emailSignup: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  doEmailSignup: PropTypes.func.isRequired,
  setEmailSignupPreviewGateVisible: PropTypes.func.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => ({
      video: state.video,
      emailSignup: state.emailSignup,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        doEmailSignup: actions.emailSignup.doEmailSignup,
        setEmailSignupPreviewGateVisible: actions.emailSignup.setEmailSignupPreviewGateVisible,
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
      }
    },
  ),
  connectStaticText({ storeKey: 'videoEmailGate' }),
)(VideoEmailGate)
